// @ts-strict-ignore
import {
  GradProgram as ApiGradProgram,
  fetchGradProgram as apiFetchGradProgram,
  hideGradProgram as apiHideGradProgram,
  unhideGradProgram as apiUnhideGradProgram,
} from 'api/orgAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '../..';
// eslint-disable-next-line no-restricted-imports
import { setError } from '../error';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { clearResults } from '../mainSearch';

// Types

export type GradProgram = ApiGradProgram & {
  isFetching: boolean;
};
export type State = {
  byOrgId: Record<string, GradProgram>;
};

type FetchGradProgramRequestAction = {
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_REQUEST';
  orgId: string;
};
type FetchGradProgramSuccessAction = {
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_SUCCESS';
  orgId: string;
  gradProgram: ApiGradProgram;
};
type ResetGradProgramAction = {
  type: 'ORG_DASHBOARD_RESET_GRAD_PROGRAMS';
};
export type Action =
  | FetchGradProgramRequestAction
  | FetchGradProgramSuccessAction
  | ResetGradProgramAction;

// Reducer

const initialState = {
  byOrgId: {},
};

export function gradProgramsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_REQUEST':
      return {
        byOrgId: {
          ...state.byOrgId,
          [action.orgId]: { ...state.byOrgId[action.orgId], isFetching: true },
        },
      };

    case 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_SUCCESS':
      return {
        byOrgId: {
          ...state.byOrgId,
          [action.orgId]: { ...action.gradProgram, isFetching: false },
        },
      };

    case 'ORG_DASHBOARD_RESET_GRAD_PROGRAMS': {
      return initialState;
    }

    default:
      return state;
  }
}

// Actions

const fetchGradProgramRequest = (
  orgId: string
): FetchGradProgramRequestAction => ({
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_REQUEST',
  orgId,
});

const fetchGradProgramSuccess = (
  orgId: string,
  gradProgram: ApiGradProgram
): FetchGradProgramSuccessAction => ({
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_SUCCESS',
  orgId,
  gradProgram,
});

export const fetchGradProgram =
  (orgId: string, force = false) =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (dispatch: Dispatch, getState: GetState): Promise<any> => {
    const state = getState();
    // @ts-expect-error fix me
    const org = state.orgDashboard.gradPrograms.byOrgId[orgId];

    if (!org || force) {
      dispatch(fetchGradProgramRequest(orgId));
      return apiFetchGradProgram(orgId)
        .then((fetchedGradProgram) => {
          dispatch(fetchGradProgramSuccess(orgId, fetchedGradProgram));
        })
        .catch((error) => {
          if (error.statusCode !== 404) {
            dispatch(setError(error));
          } else {
            // 404 handled by API caller
            throw error;
          }
        });
    }

    return Promise.resolve(org);
  };
export const updateGradProgram = fetchGradProgramSuccess;
export const resetGradProgram = () => (dispatch: Dispatch) =>
  dispatch({
    type: 'ORG_DASHBOARD_RESET_GRAD_PROGRAMS',
  });
export const hideGradProgram =
  ({ orgId }: { orgId: string }) =>
  (dispatch: Dispatch) =>
    apiHideGradProgram({
      orgId,
    })
      .then((gradProgram) => {
        dispatch(updateGradProgram(orgId, gradProgram));
        dispatch(clearResults());
      })
      .catch(setError);
export const unhideGradProgram =
  ({
    orgId,
  }: {
    orgId: string;
    listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP';
    listingId: string;
  }) =>
  (dispatch: Dispatch) =>
    apiUnhideGradProgram({
      orgId,
    })
      .then((gradProgram) => {
        dispatch(updateGradProgram(orgId, gradProgram));
        dispatch(clearResults());
      })
      .catch(setError);
